module.exports = __webpack_public_path__ + "static/media/YF60_3.589ebdef.jpg";